export enum AppContentMessage {
    OTP_CODE_SUBMISSION = "Code has been sent to this mobile number.",
    RESPONSE_STATUS_SUCCESS = "Ok",
    RESPONSE_STATUS_FAIL = "Fail",
    GROUP_CLAIM_SUBMISSION_VALIDATION = "Data is not valid. Please check again and try.",
    INDIVIDUAL_CLAIM_SUBMISSION_VALIDATION = "Data is not valid. Please check again and try.",
    OTP_VALIDATION_SUCCESS = "OTP validation success.",
    INDIVIDUAL_CLAIM_VALIDATION_SUCCESS = "Claim validation success.",
    INDIVIDUAL_POLICY_VALIDATION_SUCCESS = "Policy validation success.",
    OTP_VALIDATION_FAIL = "OTP validation failed.",
    OTP_VALIDATION_Try_Limit_Exceeded = "OTP validation try limit exceeded.",
    SENDING_SMS_FAIL = "Body or Mobile Number can not be empty or Null.",
    SENDING_EMAIL_FAIL = "Body or Email can not be empty or Null.",
    SENDING_MESSAGE = "Message sent",
}